export const UPDATE_COMPANY = "UPDATE_COMPANY";
// export const UPDATE_SUCCESS= "UPDATE_COMPANY_SUCCESS"
